import React from 'react';
import EnrollmentForm from './enrollment';
import ReCAPTCHA from "react-google-recaptcha";
import Backdrop from '@mui/material/Backdrop';
import CircularProgress from '@mui/material/CircularProgress';
import Box from '@mui/material/Box';
import GetConfig from '../config'
import CallApi from '../utils/callapi'
import Snackbar from './SnackbarWithCloseButton'
import OtpForm from './OtpForm';
import ShowCode from './ShowCode';
import { useSearchParams } from "react-router-dom";
import { useTranslation } from 'react-i18next';

export default function EnrollmentPanel() {
    const { t } = useTranslation();
    const INFO_FORM = "info_form";
    const OTP_FORM = "otp_form";
    const CODE_FORM = "code_form"

    const [currentForm, setCurrentForm] = React.useState(INFO_FORM);

    const config = GetConfig()
    var token = null;
    const grecaptcha = React.createRef();

    const [backdropOpen, setBackdropOpen] = React.useState(false);

    const [snackbarOpen, setsnackbarOpen] = React.useState(false);
    const handleSnackbarOpen = (isOpen) => {
        setsnackbarOpen(isOpen);
    }

    const [warningMsg, setWarningMsg] = React.useState('')
    const handleWarningMsg = (msg) => {
        setWarningMsg(msg)
    }

    const [enrollmentId, setEnrollmentId] = React.useState('')
    const [lang, setLang] = React.useState('en')    

    const handleSubmit = async (info) => {
        if (token == null) {
            handleSnackbarOpen(true)
            handleWarningMsg("Please check captcha first.")
            return;
        }   
       
        //token = await grecaptcha.current.executeAsync();

        setBackdropOpen(!backdropOpen);
        console.log("Drop:", backdropOpen)
        console.log(info);

        let request = {
            "captcha": token,
            "playerInfo": {
                "idType": info.IdType,
                "id": info.Id,
                "firstName": info.FirstName,
                "lastName": info.LastName,
                "gender": info.Gender,
                "title": info.Title,
                "birthday": info.Birthday,
                "countryCode": info.CountryCode,
                "phoneNumber": info.PhoneNo,
                "email": info.Email,
                "languageId":info.LanguageId,
                "nationality":info.Nationality
            },
            "preferredLangauge": info.Lang.toUpperCase()
        }
        
       
        try {
            let response = await CallApi(config.enrollment_api_url, request, null)
            setLang(info.Lang);  
           // console.log('enrollment panel language----'+info.Lang);
            setBackdropOpen(false)

            const r = await response.json();
            if (response.status >= 400) {
                console.error('Backend validation error:', r);
                setsnackbarOpen(true);
                if (r.title === "ExistingIDNDobEnrollmentException") {
                    setWarningMsg(t('existing_user_error'));
                } else {
                    setWarningMsg(t('signup_error'));
                }
                window.grecaptcha.reset();
            }
            else {
                setEnrollmentId(r.enrollmentId);
                setCurrentForm(OTP_FORM);
            }

            console.log(request);
            console.log(response)
            console.log(r)
            

        } catch (error) {
            setBackdropOpen(false)
            console.error('API call failed:', error)
            setsnackbarOpen(true);
            setWarningMsg(t('signup_error'))

            window.grecaptcha.reset();
        }
    };

    /**
     * User submitted OTP
     * @param {*} data otp password 
     */
    const onOtpFormSubmit = async (data, id) => {

        console.log(`EnrollmentId: ${id}`)
        setBackdropOpen(true)

        let request = {
            EnrollmentId: id,
            Password: data.otp
        }

        await verifyOtp(request);
    }

    const onCaptchaChange = (value) => {
        token = value;
        console.log("Captcha value:", value);
    }

    const mySiteKey = config.captcha_site_key;

    const [searchParams] = useSearchParams();
    
    const verifyOtp = async (request) => {
        try {
            let response = await CallApi(config.verify_otp_url, request, null)
            const r = await response.json();
            setBackdropOpen(false);

            if (response.status >= 400) {
                console.error('Backend validation error:', r);
                setsnackbarOpen(true);
                if (r.title === "ExistingIDNDobEnrollmentException") {
                    setWarningMsg(t('existing_user_error'));
                } else {
                    setWarningMsg(t('signup_error'));
                }
            }
            else {
                setCurrentForm(CODE_FORM)
            }
        } catch (error) {
            console.error('API call failed:', error)
            setsnackbarOpen(true);
            setWarningMsg(t('signup_error'))
        }
    }

    React.useEffect(() => {
        const formId = searchParams.get("formId");
        const otp = searchParams.get("otp");
        console.log(`Form ID: ${formId}, OTP: ${otp}`);

        if (formId && otp) {
            setBackdropOpen(true);

            let request = {
                EnrollmentId: formId,
                Password: otp
            }

            verifyOtp(request)
        }

        // eslint-disable-next-line
    },[]);

    return (
        <div>
            <Backdrop
                sx={{ color: '#fff', zIndex: (theme) => theme.zIndex.drawer + 1 }}
                open={backdropOpen}
            // onClick={handleClose}
            >
                <CircularProgress color="inherit" />
            </Backdrop>
            {
                currentForm === INFO_FORM &&
                <Box>
                    <EnrollmentForm onSubmit={handleSubmit} />

                    <div style={{ display: 'flex', justifyContent: 'center', margin: '20px 0' }}>
                        <ReCAPTCHA
                            sitekey={mySiteKey}
                            onChange={onCaptchaChange}
                            ref={grecaptcha}                        
                        />
                    </div>

                </Box>
            }
            {
                
                currentForm === OTP_FORM &&    
                <OtpForm onSubmit={onOtpFormSubmit} enrollmentId={enrollmentId} language={lang}/>
            }
            {
                currentForm === CODE_FORM &&
                <ShowCode language={lang} />
            }
            <Snackbar
                open={snackbarOpen}
                message={warningMsg}
                handleOpen={handleSnackbarOpen}
            />
        </div>
    );
}